import React from 'react';
type SectionProps = {
  n: string;
  label: string;
  id?: string;
  /** Extra classes on the row, e.g. "gridpaper" or a page-specific hook. */
  className?: string;
  /** Extra classes on the content column. */
  contentClassName?: string;
  /** Drop the top rule (the first section under the nav). */
  noTop?: boolean;
  children: React.ReactNode;
};

/**
 * The layout unit of the site: a 260px margin column carrying the mono section
 * number and label, then the content column. Rows share one horizontal rule.
 */
export function Section({
  n,
  label,
  id,
  className,
  contentClassName,
  noTop,
  children
}: SectionProps) {
  const cls = ['sec', noTop ? 'nt' : '', className ?? ''].filter(Boolean).join(' ');
  return <section id={id} className={cls} data-id="element-273" data-mp="7nws57y3kio6">
      <div className="sec-m" data-id="element-274" data-mp="7mvgb199bs5e">
        <div className="sec-n" data-id="element-275" data-mp="vespslp8i83c">{n}</div>
        <div className="sec-l" data-id="element-276" data-mp="vdr5rrq8qb9h">{label}</div>
      </div>
      <div className={['sec-c', contentClassName ?? ''].filter(Boolean).join(' ')} data-id="element-277" data-mp="104ze0kfu3ql2">{children}</div>
    </section>;
}